var map = {
	"./DIPLOMA CIENCIAS QUIROFISICAS.png": 3467,
	"./DIPLOMA ENFERMERIA.png": 9532,
	"./DIPLOMA MASAJES .png": 2682,
	"./DIPLOMA QUIROPRACTICA.png": 8385,
	"./EC0616 AUXILIAR DE ENFERMERIA.png": 1637,
	"./EC076.png": 2653,
	"./EC1375.png": 7680
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 114;